export default __webpack_public_path__ + "locales/nl/InviteDialog.json?hash=b664b8b428c20ce9794e111029696a17";